import { CommonFunctions } from '../static/common-functions';
//import { Console } from '@angular/core/src/console';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';
import { RelatedJobBus } from './RelatedJobBus';
import { ConstructionChartDetail } from './ConstructionChartDetail';
import { InvoiceDrawBus } from './InvoiceDrawBus';
import { DispatchNoteBus } from './DispatchNoteBus';

export class CnstContractBus extends BaseBus
{
  CID(): any {
    return this.dispatchId;
  }
    constructor(data: CnstContractBus) {
        super(data);
        if (CommonFunctions.hasValue(data)) {
            if (CommonFunctions.hasArrayElementValue(data.relatedJobs)) {
                let arr = [];
                for (let i = 0; i < data.relatedJobs.length; i++) {
                    let busObj: RelatedJobBus = new RelatedJobBus(data.relatedJobs[i]);
                    arr.push(busObj);
                }
                this.relatedJobs = arr;
            }
            //this.setEmptyStringGuidToNull = true;
        }
    //Object.assign(this, data);
    //try {
    //  this.receivedDateTime = CommonFunctions.getDate(data.receivedDateTime);
    //  this.insertDt = CommonFunctions.getDate(data.insertDt);
    //  this.updateDt = CommonFunctions.getDate(data.updateDt);
    //  this.estimatedBeginDate = CommonFunctions.getDate(data.estimatedBeginDate);
    //  this.estimatedEndDate = CommonFunctions.getDate(data.estimatedEndDate);

    //  this.jobWarrantyEndDate = CommonFunctions.getDate(data.jobWarrantyEndDate);
    //  this.refTrackNbrDt = CommonFunctions.getDate(data.refTrackNbrDt);
    //  this.finalBillingDt = CommonFunctions.getDate(data.finalBillingDt);
    //  this.sageDt = CommonFunctions.getDate(data.sageDt);
    //}
    //catch {

    //}
  }
    initialize(data: CnstContractBus) {
    super.initialize(data);
    try {
      this.receivedDateTime = CommonFunctions.getDate(data.receivedDateTime);
      this.insertDt = CommonFunctions.getDate(data.insertDt);
      this.updateDt = CommonFunctions.getDate(data.updateDt);
      this.estimatedBeginDate = CommonFunctions.getDate(data.estimatedBeginDate);
      this.estimatedEndDate = CommonFunctions.getDate(data.estimatedEndDate);

      this.jobWarrantyEndDate = CommonFunctions.getDate(data.jobWarrantyEndDate);
      this.refTrackNbrDt = CommonFunctions.getDate(data.refTrackNbrDt);
      this.finalBillingDt = CommonFunctions.getDate(data.finalBillingDt);
      this.sageDt = CommonFunctions.getDate(data.sageDt);
        this.refreshDate = CommonFunctions.getDate(data.refreshDate);
    }
    catch {

    }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.receivedDateTime = DateFunctions.getDateNow();
        this.receivedById = personId;
        this.dispatchStatusId = CommonValues.Dispatch_ReadyForDispatch;
        this.priorityId = CommonValues.Priority_Normal;
        this.isConstruction = true;
        this.isProgressBill = true;
    }
    setFromForm(data: CnstContractBus) {
    super.setFromForm(data);
    let dateNow = CommonFunctions.getDateNow();
    if (this.hasId) {
      this.updateDt = dateNow;
      this.insertDt = data.insertDt;
      this.insertUserId = data.insertUserId;
    }
    else {
      this.insertDt = dateNow;
      this.insertUserId = data.insertUserId;
    }
    
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateDt = date;
            this.updateUserid = userId;
            if (!DateFunctions.isValidDate(this.insertDt)) {
                this.insertDt = date;
            }
            if (!CommonFunctions.hasValue(this.insertUserId)) {
                this.insertUserId = userId;
            }
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.companyId = companyId;
            this.updateDt = date;
            this.updateUserid = userId;
        }
    }
    setBeforeSave() {
        this.receivedDateTime = DateFunctions.getDateTimeWithUTCOffset(this.receivedDateTime);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
//        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.isConstruction = true;
        if (DateFunctions.isValidDate(this.estimatedBeginDate)) {
            this.estimatedBeginDate = DateFunctions.getDateWithUTCOffset(this.estimatedBeginDate);
        }
        if (DateFunctions.isValidDate(this.estimatedEndDate)) {
            this.estimatedEndDate = DateFunctions.getDateWithUTCOffset(this.estimatedEndDate);
        }
        if (DateFunctions.isValidDate(this.jobWarrantyEndDate)) {
            this.jobWarrantyEndDate = DateFunctions.getDateWithUTCOffset(this.jobWarrantyEndDate);
        }
        if (DateFunctions.isValidDate(this.refTrackNbrDt)) {
            this.refTrackNbrDt = DateFunctions.getDateWithUTCOffset(this.refTrackNbrDt);
        }
        if (DateFunctions.isValidDate(this.finalBillingDt)) {
            this.finalBillingDt = DateFunctions.getDateWithUTCOffset(this.finalBillingDt);
        }
        if (DateFunctions.isValidDate(this.sageDt)) {
            this.sageDt = DateFunctions.getDateWithUTCOffset(this.sageDt);
        }
        if (DateFunctions.isValidDate(this.refreshDate)) {
            this.refreshDate = DateFunctions.getDateTimeWithUTCOffset(this.refreshDate);
        }
        //super.setBeforeSave();
    }
dispatchId: any;
customerId: any;
locationId: any;
companyId: any;
priorityId: any;
dispatchStatusId: any;
receivedById: any;
quoteId: any;
invoiceId: any;
receivedDateTime: Date;
needsQuote: boolean;
notToExceed: number;
dispatchNumber: string;
ponumber: string;
whoCalledName: string;
dispatchReason: string;
insertUserId: any;
insertDt: Date;
updateUserid: any;
updateDt: Date;
wonumber: string;
accountClassId: any;
callbackId: any;
isProgressBill: boolean;
estimatedBeginDate: Date;
estimatedEndDate: Date;
isConstruction: boolean;
contractPrice: number;
pooverrideUserId: any;
estimatedCost: number;
relatedJobTypeId: any;
jobWarrantyEndDate: Date;
masterJobId: any;
foremanId: any;
refTrackNbr: string;
refTrackNbrDt: Date;
refTrackNbrUserId: any;
minimumSkill: number;
pmprice: number;
labTaxRate: number;
matTaxRate: number;
otherTaxRate: number;
isRetailTax: boolean;
stockReplenishWh: any;
finalBillingDt: Date;
jobClassificationId: any;
contractAdminId: any;
contractProjAdminId: any;
wipcomplete: boolean;
contractProjEstId: any;
certPayrollRequired: boolean;
drawDateInfo: string;
changeOrderInfo: string;
sageDt: Date;
autoCreateId: string;
dispatchRepairCatId: any;
contractDivisionId: any;
contractJrProjAdminId: any;
dispatchActionCodesId: any;
dispatchCauseCodesId: any;
dispatchFailureCodesId: any;
dispatchProblemCodeId: any;
refreshDate: Date;

    dispatchNotes: DispatchNoteBus[];
jobChangeOrders: RelatedJobBus[];
jobManWarranties: RelatedJobBus[];
jobPostWarranties: RelatedJobBus[];
jobChangeRequests: RelatedJobBus[];
relatedJobs: RelatedJobBus[];
costCompare: ConstructionChartDetail[];
invoiceDraws: InvoiceDrawBus[];
draws_TotalPayments: number;
draws_TotalWithRet: number;
draws_TotalLessRet: number;
draws_TotalRet: number;
}
